module.exports = __webpack_public_path__ + "static/img/banner0.05c46ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner0.png
// module id = V8MZ
// module chunks = 192